// http://www.yuanjingyan.com/article/1081820236
// [vue-cookies] : https://www.jianshu.com/p/60c13168cc8f

import Vue from 'vue'
import { routeEventFix } from '@/config/routePrefix'
import VueCookies from 'vue-cookies'

const main = {
  install(Vue) {
    ;(Vue.prototype.$router_replace = function (ars) {
      ars.path = routeEventFix(ars.path)
      this.$router.replace(ars).catch((err) => err)
    }),
      (Vue.prototype.$router_push = function (ars) {
        ars.path = routeEventFix(ars.path)
        this.$router.push(ars).catch((err) => err)
      })
  },
}

Vue.use(main)
Vue.use(VueCookies)
